import { render, staticRenderFns } from "./partTinymce.vue?vue&type=template&id=f562371a"
import script from "./partTinymce.vue?vue&type=script&lang=js"
export * from "./partTinymce.vue?vue&type=script&lang=js"
import style0 from "./partTinymce.vue?vue&type=style&index=0&id=f562371a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports